chat:
  actions:
    retry: Retry
  message:
    character-name:
      airi: AIRI
      core-system: 核心系統
      you: 你
  reasoning: 推理
message: 說點什麼...
send-mode:
  title: 傳送按鍵
  enter: Enter
  ctrl-enter: Ctrl + Enter
  double-enter: Enter + Enter
operations:
  load-models: 載入模型
  load-models-status:
    loading: 模型載入中
    ready: 已就緒
select-a-audio-input: 選擇一個音訊輸入裝置
select-a-model: 選擇一個模型
select-a-voice: 選擇一個聲線
viewers:
  debug-menu:
    emotions: 表情
    emotions-btn:
      angry: '😠 生氣'
      awkward: '😳 尷尬'
      happy: '😄 開心'
      neutral: '🙂 日常'
      question: '🤔 疑問'
      sad: '😫 難過'
      surprised: '🤯 驚喜'
      think: '🤨 思考'
    vrm:
      camera: 攝影機
      model:
        title: 模型
profile-switcher:
  no-profile: 無設定檔
  no-profiles: 暫時沒有設定檔
  save-as-new: 儲存為新設定檔
  new-profile-name: 設定檔名稱
  manage: 管理設定檔
promo-banner:
  items:
    signin:
      watermark: Moon
      fallbackLabel: Moon Gift
      title: 7日簽到
      eventName: Sign in to claim stardust, avatar frames, and launch gifts.
      date: 03/28 - 04/10
      reward: Up to 120 Stardust
      cta: Sign In
    build:
      watermark: Build
      fallbackLabel: Build Bonus
      title: Supply Box Bonus
      eventName: Finish construction tasks to earn bonus vouchers and double materials.
      date: 03/30 - 04/12
      reward: 5 Supply Vouchers + Upgrade Materials
      cta: 查看任務
    spring:
      watermark: 春天
      fallbackLabel: Spring Draw
      title: Capsule Carnival
      eventName: Join the spring draw to unlock bubbles, charms, and themed furniture.
      date: 04/01 - 04/18
      reward: Half-Price First Pull + Rare Charm
      cta: Draw Now
    coupon:
      watermark: Talk
      fallbackLabel: Coupon
      title: Top-Up Coupon
      eventName: Finish chat interactions to claim coupons for expansion and voice packs.
      date: 04/02 - 04/20
      reward: Save 6 on 30 / Save 15 on 68
      cta: Claim Coupon
    home:
      watermark: Home
      fallbackLabel: Room Theme
      title: Spring Theme Update
      eventName: Unlock window, desk, and night-lamp themes to refresh your room.
      date: 04/05 - 04/22
      reward: Free Theme Draw Ticket on Sign-in
      cta: View Theme
waiting: 等待中
websocket-status:
  connected: WebSocket connected
  disconnected: WebSocket disconnected
  open-settings: Open WebSocket settings
